import React from "react";
import { useCustomNavigation } from "../../utility/Utility.ts";
import { useTranslation } from "react-i18next";
import { NavbarElementProps, NavbarMenuComponentProps } from "../../constants/interface.ts";
import AccordionComponent2 from "../AccordionComponent2/AccordionComponent2.tsx";
import { navbarElements } from './data.ts';

const NavbarMenuComponent =  (props: NavbarMenuComponentProps) => {
    const { handleCloseMenu } = props;
    const {t} = useTranslation();
    const customNavigate = useCustomNavigation();

    const handleNavigation = (isRouterLink: boolean, link: string) => {
        customNavigate(isRouterLink, link);
        handleCloseMenu(); /* Close the menu when navigating to a new page */
    };

    const NavbarItem = (arr: NavbarElementProps[], prevKey: string) => { /* Recursive function to render the navbar items. Currently, I am writing it here to avoid reinitializing the functions and variables used inside. */
        return arr.map((element, i: number) => {
            const newKey = `${prevKey}-${i}`;

            if(element.link){
                return (<div key={newKey}>
                    <a href={element.link || ''} className="text-sm font-normal text-gray-717 cursor-pointer hover:text-blue-700"
                        style={{ ...((element.link === 'no-data') && {cursor: "not-allowed", opacity: 0.5})}} //disabling for the 'no data', remove the code later
                        onClick={(e) => {
                            e.preventDefault(); // to previde the "Open link in new tab" option, on mouse right click
                            handleNavigation(true, (element.link || ''));
                        }}
                        >
                        {t(element.title) || ''}
                    </a>
                </div>)
            } else {
                return (<React.Fragment key={newKey}>
                    <AccordionComponent2
                        header={
                            (isOpen: boolean) => (
                            <p className='flex gap-2'>
                                <span>{t(element.title)}</span>
                                <span><i className={`fa-solid fa-chevron-right ${isOpen && 'rotate-90'}`}></i></span>
                            </p>)
                        }
                        content={
                            (isOpen: boolean) => (<div className="grid gap-2 p-2">{ (element.list) && NavbarItem(element.list, newKey) } </div>)
                        }
                    />
                </React.Fragment>)
            }
        });
    };

    return (
        <div id="navbar-menu">
            <div className="py-6 px-5">
                <img loading="lazy" src={"/assets/images/svg/Innovii-logo-blue.svg"} alt="innovii" className="w-24 cursor-pointer"  onClick={() => handleNavigation(true, '')} />
                <img loading="lazy" src="/assets/images/svg/close-icon.svg" alt="X" className="w-6 cursor-pointer" onClick={() => handleCloseMenu()} />
            </div>
            <div className="hide-scrollbar p-5">
                <div className="flex flex-col gap-2">
                    {
                        NavbarItem(navbarElements, '0')
                    }
                </div>
                <div className="flex flex-wrap gap-3 justify-center mt-16">
                    <button className="btn btn-trans-black" onClick={() => handleNavigation(true, 'services/digital-transformation')}>{t('NAVBAR.LEARN_MORE')}</button>
                    <button className="btn btn-blue-white" onClick={() => handleNavigation(true, 'contact-us')}>{t('NAVBAR.CONTACT_US')}</button>
                </div>
            </div>
        </div>
    );
};

export default NavbarMenuComponent;